import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './Css/sideBar.css';
import { IoHomeOutline } from "react-icons/io5";
import { FaRegUser } from "react-icons/fa6";
import { FiUsers } from "react-icons/fi";
import { GoListOrdered } from "react-icons/go";
import { HiOutlineWrenchScrewdriver ,HiOutlineCalendarDays } from "react-icons/hi2";
import { LiaAndroid } from "react-icons/lia";
import { IoMdClose } from "react-icons/io";

import { BsGlobeAmericas } from "react-icons/bs";
import { CiMoneyBill } from "react-icons/ci";
import { CiCreditCard1 } from "react-icons/ci";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { LuMapPin } from "react-icons/lu";
const SideBar = ({ isOpen, togglesidebarbutton }) => {
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const [permissions, setPermissions] = useState({});
  const [pagesOpen, setPagesOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const role = (localStorage.getItem('userRole'));
  useEffect(() => {

    const storedPermissions = JSON.parse(localStorage.getItem('userPermissions')) || {};
    setPermissions(storedPermissions);

  }, []);

  const handleToggleSubMenu = (menu) => {
    setOpenSubMenu(openSubMenu === menu ? null : menu);
  };

  const togglePages = () => setPagesOpen(!pagesOpen);
  const toggleSettings = () => setSettingsOpen(!settingsOpen);

  const renderMenuItem = (name, key, icon, img, subItems, togglesidebarbutton) => {
    if (role === 'Admin' || permissions[key]) {
      return (
        <li key={key}>
          {subItems ? (
            <>
              <a onClick={() => handleToggleSubMenu(key)} className='d-flex justify-content-between align-items-center'>
                <div className='d-flex gap-2 align-items-center'>
                  <div className='icon_sidebar'>
                    {icon ? icon : <img src={img} alt={name} style={{ marginInlineEnd: 10 }} />}
                  </div>
                  <span>{name}</span>
                </div>
                {/* {`${openSubMenu === key ? <IoIosArrowDown/> : <IoIosArrowForward />}`} */}
                {openSubMenu === key ? <IoIosArrowDown /> : <IoIosArrowForward />}
              </a>
              {openSubMenu === key && (
                <ul className='submenudropdown'>
                  {subItems.map((subItem) => (
                    <li key={subItem.key} className='submenudropdownli'>
                      <NavLink to={subItem.path} className="sub-link" activeClassName="active">
                        {subItem.name}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              )}
            </>
          ) : (
            <NavLink to={`/${key}`} activeClassName="active">
              <div className='d-flex gap-2 align-items-center'>
                <div className='icon_sidebar'>
                  {icon ? icon : <img src={img} alt={name} style={{ marginInlineEnd: 10 }} />}
                </div>
                <span>
                  {name}
                </span>
              </div>
            </NavLink>
          )}
        </li>
      );
    }
    return null;
  };

  const menuItems = [
    { name: 'Dashboard', key: 'dashboard', icon: <IoHomeOutline /> },
    {
      name: 'Customers',
      key: 'users',
      icon: <FaRegUser />,
      subItems: [
        { name: 'All', path: '/users' },
        { name: 'Active', path: '/active-users' },
        { name: 'Inactive', path: '/inactive-users' },
        // { name: 'Subscription', path: '/subcription-users' },
      ],
    },
    {
      name: 'Sellers',
      key: 'sallers',
      icon: <FaRegUser />,
      subItems: [
        { name: 'All', path: '/sallers' },
        { name: 'Active', path: '/active-sallers' },
        { name: 'Inactive', path: '/inactive-sallers' },
        { name: 'Bank List', path: '/sallers-bank-list' },
        { name: 'Commission List', path: '/commision-list' },
        // { name: 'Subscription', path: '/subcription-users' },
      ],
    },
    {
      name: 'Subscriptions Customers',
      key: 'subcriptionUsers',
      icon: <FaRegUser/>,
      subItems: [
        { name: 'All Subscription', path: '/subcription-all-users' },
       { name: 'Pending Subscription', path: '/subcription-panding-users' },
        { name: 'Active Subscription', path: '/subcription-active-users' },
        { name: 'Expire Subscription', path: '/subcription-expire-users' },
      ],
    },

    {
      name: 'Owner',
      key: 'vender',
      icon: <FiUsers />,
      subItems: [

        { name: 'Registered', path: '/register-vendor' },
        { name: 'All', path: '/vendor' },
        { name: 'Active', path: '/active-vendor' },
        { name: 'Inactive', path: '/inactive-vendor' },
        // { name: 'Vendor Wallet', path: '/vendor-wallet' },

      ],
    },

    // {
    //   name: 'Order',
    //   key: 'order',
    //   icon: <GoListOrdered/>,
    //   subItems: [
    //     // { name: 'Order Placed', path: '/pending-order' },
    //     { name: 'Pending Orders', path: '/pending-orders' },
    //     // { name: 'Ongoing Order', path: '/ongoing-order' },
    //     { name: 'Confirmed Orders', path: '/confirmed-order' },
    //     // { name: 'Ongoing Orders ', path: '/ongoing-orders' },
    //     // { name: 'Service Started ', path: '/service-start' },
    //     { name: 'Cancelled Orders', path: '/cancelled-order' },
    //     { name: 'Completed Orders', path: '/completed-order' },
    //     { name: 'All Service', path: '/order' },
    //   ],
    // },

    {
      name: 'Service',
      key: 'services',
      icon: <HiOutlineWrenchScrewdriver />,
      subItems: [
        { name: 'Category', path: '/category' },
        { name: 'SubCategory', path: '/subcategory' },
        // { name: 'Shop List', path: '/shop-list' },
        // { name: 'Brand', path: '/brand' },
        // { name: 'Add Vehicle', path: '/vehicle' },
        // { name: 'Subscription Plan', path: '/plan' },
        // { name: 'Add Addons', path: '/addons' },
      ],
    },
    {
      name: 'Shop Management',
      key: 'shopManagement',
      icon: <HiOutlineWrenchScrewdriver />,
      subItems: [
        { name: 'Pending', path: '/pending' },
        { name: 'Approve', path: '/approve' },
        { name: 'Reject', path: '/reject' },
      ],
    },
    {
      name: 'Menu Management',
      key: 'mainManagement',
      icon: <HiOutlineWrenchScrewdriver />,
      subItems: [
        { name: 'Menu', path: '/menu-list' },
        { name: 'Post', path: '/post-list' },
        { name: 'Banner', path: '/poster-list' },
      ],
    },
    {
      name: 'Membership Management',
      key: 'membershipManagement',
      icon: <HiOutlineWrenchScrewdriver />,
      subItems: [
        { name: 'Membership Category', path: '/membership-category' },
        { name: 'Membership List', path: '/membership-list' },
        { name: 'Membership Service', path: '/membership-service-list' },
        { name: 'Membership Coupon', path: '/couponnew' },
        { name: 'Revert Coupon', path: '/revert-coupon-list' },
        { name: 'Applied Coupon History', path: '/revert-coupon-history' },
      ],
    },
    {
      name: 'Withdraw Management',
      key: 'WithdrawManagement',
      icon: <HiOutlineWrenchScrewdriver />,
      subItems: [
        { name: 'All Withdraw', path: '/all-withdraw-list' },
        { name: 'Pending', path: '/pending-withdraw-list' },
        { name: 'Approve', path: '/approve-withdraw-list' },
        { name: 'Reject', path: '/rejected-withdraw-list' },
      ],
    },
    {
      name: 'Vendor Withdraw Management',
      key: 'vendorWithdrawManagement',
      icon: <HiOutlineWrenchScrewdriver />,
      subItems: [
        { name: ' Vendor All Withdraw', path: '/vendor-all-withdraw-list' },
        { name: ' Vendor Pending', path: '/vendor-pending-withdraw-list' },
        { name: 'Vendor Approve', path: '/vendor-approve-withdraw-list' },
        { name: 'Vendor Reject', path: '/vendor-rejected-withdraw-list' },

      ],
    },
    {
      name: 'Event Management',
      key: 'EventManagement',
       icon: <HiOutlineCalendarDays />,
      subItems: [
       { name: 'Events', path: '/event-list' },
       { name: 'Event Ticket', path: '/event-ticket-list' },
       { name: 'Event Booking', path: '/event-booking-list' },
      ],
    },

    {
      name: 'App Settings',
      key: 'appsettings',
      icon: <LiaAndroid />,
      subItems: [
        { name: 'Profile', path: '/profile' },
        { name: 'Admin Add User', path: '/admin' },
        { name: 'Refer & Earn', path: '/refer' },
        // { name: 'Provider', path: '/provider-list' },
        // { name: 'Coupon List', path: '/coupon-list' },
    
        // { name: 'Passes List', path: '/passes-list' },
        
        // { name: 'Time Slot Management', path: '/time-slot' },
        // { name: 'Number Of Booking', path: '/numberofbooking' },
        { name: 'APP General Settings', path: '/app-setting' },
        { name: 'Rezorpay Settings', path: '/rezorpay-setting' },
        { name: 'Home Slider', path: '/home-slider' },
        { name: 'Contact', path: '/contact-us' },
        // { name: 'Holiday', path: '/holiday' },

      ],
    },

    {
      name: 'Website Settings',
      key: 'websettings',
      icon: <BsGlobeAmericas />,
      subItems: [
        { name: 'Website', path: '/website' },
        { name: 'Happy Customer', path: '/happy-customer' },
        { name: 'Feedback', path: '/feedback' },
        { name: 'Hero Section', path: '/web-slider' },
        { name: 'Advertisement Section', path: '/web-advertisement' },
        { name: 'Enquiry', path: '/enquiry-list' },
        // { name: 'Vendor Review', path: '/vendor-review' },
      ],
    },


    // {
    //   name: 'GST Report',
    //   key: 'gstreport',
    //   icon: <CiMoneyBill/>,
    //   subItems: [
    //     { name: 'Sales', path: '/completed-order' },
    //     { name: 'Bill Details', path: '/purchase' },
    //     { name: 'Other Expenses', path: '/other-expenses' },
    //     { name: 'Balance Sheet', path: '/balance-sheet' },
    //   ],
    // },

    { name: 'Location Manager', key: 'district', icon: <LuMapPin /> },

    // { name: 'Salary Managment', key: 'salary-managment', icon: <CiCreditCard1/> },

    {
      name: 'Notification',
      key: 'notification',
      icon: <CiMoneyBill />,
      subItems: [
        { name: 'Register Notification', path: '/push-notification' },
        { name: 'Push Notification', path: '/notification' },
      ],
    },

    {
      name: 'Pages',
      key: 'pages',
      img: 'img/page-icon.svg',
      subItems: [
        { name: 'Terms and Condition', path: '/terms-and-condition' },
        { name: 'Privacy Policy', path: '/privacy-policy' },
        { name: 'Cancellation Policy', path: '/cancellation-policy' },
        { name: 'About-Us', path: '/about-us' },
      ],
    },

  ];

  return (
    <div className={`col-md-3 left_col sidebar ${isOpen ? 'open' : 'closed'}`}>
      <div className="left_col scroll-view">
        <div className="navbar nav_title" style={{ border: 0 }}>
          <NavLink to="/dashboard" className="site_title">
            <img src="img/PaarLogo.png" alt="Logo" />
            {/* <img src="img/PaarLogo.png" alt="Logo" /> */}
          </NavLink>
          <div className='closebuttonside' onClick={togglesidebarbutton}>
            <IoMdClose />
          </div>
        </div>
        <div className="clearfix" />
        <div id="sidebar-menu" className="main_menu_side hidden-print main_menu">
          <div className="menu_section">
            <ul className="nav side-menu">
              {menuItems.map((item) => renderMenuItem(item.name, item.key, item.icon, item.img, item.subItems))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideBar;

